/**
 * 存储键值对
 * @param { String } key
 * @param {*} value
 */
const SET_VALUE = function(key, value) {
  if (typeof value != "string") {
    // "a" --> ""a""
    value = JSON.stringify(value);
  }
  if (window.localStorage) {
    localStorage[key] = value;
  } else {
    setCookie(key, value)
    // $.cookie(key, value, { path: "/" });
  }
};

/**
 *  移除 localstorage 的某个键值对
 * @param {String} key
 */
const REMOVE_VALUE = function(key, tag) {
  if (window.localStorage) {
    localStorage.removeItem(key);
  } else {
    delCookie(key)
    // $.cookie(key, null, {path: "/"});
  }
  if(tag === 'cookie'){
    delCookie(key)
  }
};

/**
 *  获取 localStorage 的键对应的值
 * @param {String} key
 */
const GET_VALUE = function(key) {
  var value = null;
  if (window.localStorage) {
    value = localStorage[key];
  } else {
    // value = $.cookie(key);
    value = getCookie(key)
  }

  try {
    value = JSON.parse(value);
  } catch (error) {
    value = value;
  }
  return value;
};

/**
 *  清空缓存
 */
const CLEAR_VALUE = function() {
  localStorage.clear();
  clearAllCookie();
};

const setCookie = (name,value) =>{
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days*24*60*60*1000);
  document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+";path=/";;
}

//读取cookies
const getCookie = name =>{
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");

  if(arr=document.cookie.match(reg)){
    var v=arr[2];
    if (v != null && v != "" && v != "undefined"){
      return decodeURIComponent(v);
    }
    return "";
  }else{
    return null;
  }
}

//删除cookies
const delCookie = (name)=>{
  var exp = new Date();
  exp.setTime(exp.getTime() - 10000);
  var cval=getCookie(name);
  if(cval!=null){
    document.cookie= name + "="+cval+";expires="+exp.toGMTString()+";path=/";
  }
}
// 清空所有 cookie
const clearAllCookie = ()=> {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;){
      var name = keys[i]
      var date=new Date();
      date.setTime(date.getTime()-10000);
      document.cookie=name+"=; expire="+date.toGMTString()+"; path=/";
    }
  }
}


export { SET_VALUE, GET_VALUE, REMOVE_VALUE, CLEAR_VALUE };
